import { initOpnFormContactForm } from './opnform-contact';
import { initFaqFilter } from './faq-filter';

document.addEventListener('DOMContentLoaded', () => {
	const navbar = document.getElementById('cp-navbar');
	const navCollapse = document.getElementById('navMenu');
	const collapseClass = window.bootstrap?.Collapse || window.understrap?.Collapse;
	const hamburger = document.querySelector('#cp-navbar .hamburger');
	const hero = document.getElementById('hero');
	const hasHero = Boolean(hero);

	if (navbar) {
		const handleNavbarState = () => {
			const isScrolled = !hasHero || window.scrollY > 80;
			navbar.classList.toggle('scrolled', isScrolled);
			navbar.classList.toggle('bg-dark', isScrolled);
		};

		handleNavbarState();
		window.addEventListener('scroll', handleNavbarState, { passive: true });
	}

	if (navCollapse && collapseClass) {
		const syncHamburgerState = () => {
			if (!hamburger) {
				return;
			}

			const isOpen = navCollapse.classList.contains('show');
			hamburger.classList.toggle('is-active', isOpen);
			hamburger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
		};

		syncHamburgerState();
		hamburger?.addEventListener('click', () => {
			const willOpen = !navCollapse.classList.contains('show');
			hamburger.classList.toggle('is-active', willOpen);
			hamburger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
		});
		navCollapse.addEventListener('shown.bs.collapse', syncHamburgerState);
		navCollapse.addEventListener('hidden.bs.collapse', syncHamburgerState);

		document.querySelectorAll('#navMenu .nav-link, #navMenu .btn-cp-nav').forEach((link) => {
			link.addEventListener('click', () => {
				if (navCollapse.classList.contains('show')) {
					collapseClass.getOrCreateInstance(navCollapse).hide();
				}
			});
		});
	}

	if (navbar) {
		document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
			anchor.addEventListener('click', (event) => {
				const hash = anchor.getAttribute('href');
				if (!hash || hash === '#') {
					return;
				}

				const target = document.querySelector(hash);
				if (!target) {
					return;
				}

				event.preventDefault();
				const offset = navbar.offsetHeight + 16;
				const top = target.getBoundingClientRect().top + window.scrollY - offset;
				window.scrollTo({ top, behavior: 'smooth' });
			});
		});

		const sections = document.querySelectorAll('section[id]');
		const navLinks = document.querySelectorAll('#navMenu .nav-link');

		if (sections.length && navLinks.length && 'IntersectionObserver' in window) {
			const sectionObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) {
							return;
						}

						navLinks.forEach((link) => link.classList.remove('active'));

						const activeLink = document.querySelector(`#navMenu a[href="#${entry.target.id}"]`);
						if (activeLink) {
							activeLink.classList.add('active');
						}
					});
				},
				{
					threshold: 0.3,
					rootMargin: `-${navbar.offsetHeight}px 0px 0px 0px`,
				}
			);

			sections.forEach((section) => sectionObserver.observe(section));
		}
	}

	if (typeof window.AOS !== 'undefined') {
		window.AOS.init({
			once: true,
			duration: 600,
			offset: 80,
		});
	}

	initOpnFormContactForm();
	initFaqFilter();
});
